/* Greenington — colour swatches on product cards (snippets/gh-card.liquid) and
   on group-page collection tiles (sections/gh-subcollections.liquid, via
   snippets/gh-swatches.liquid). A card that has [data-gh-card-link] also gets
   its link re-pointed (product cards); collection tiles keep linking to the
   collection.
   Hovering (or focusing) a swatch shows that colour's main picture in the card
   and points the card link at that colour's page; leaving the card restores the
   card's own colour. Each colour lives on its own product page, so its picture
   is read from /products/<handle>.js on first use and cached; the swap happens
   only once the new picture has loaded, so the card never flashes empty. */
(function () {
  var cache = {};

  function sizedUrl(src, width) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = window.location.protocol + src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function colourImage(handle) {
    if (!cache[handle]) {
      /* a colour that is a variant of another listing links as "handle?variant=ID" (leather seats) */
      var parts = handle.split('?variant=');
      cache[handle] = fetch('/products/' + parts[0] + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return null;
          var src = p.featured_image || (p.media && p.media[0] && p.media[0].src);
          if (parts[1] && p.variants) {
            p.variants.forEach(function (v) { if (String(v.id) === parts[1] && v.featured_image) src = v.featured_image.src; });
          }
          if (!src) return null;
          return {
            src: sizedUrl(src, 1200),
            srcset: [400, 800, 1200].map(function (w) { return sizedUrl(src, w) + ' ' + w + 'w'; }).join(', '),
            url: parts[1] ? '/products/' + handle : (p.url || '/products/' + handle),
            title: p.title || ''
          };
        })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  function remember(card) {
    if (card.__ghOriginal) return card.__ghOriginal;
    var img = card.querySelector('[data-gh-card-img] img');
    var link = card.querySelector('[data-gh-card-link]');
    card.__ghOriginal = {
      src: img ? img.getAttribute('src') : '',
      srcset: img ? img.getAttribute('srcset') : '',
      url: link ? link.getAttribute('href') : '',
      title: (card.querySelector('.gh-card__title') || {}).textContent || ''
    };
    return card.__ghOriginal;
  }

  function show(card, pic, swatch) {
    var img = card.querySelector('[data-gh-card-img] img');
    var link = card.querySelector('[data-gh-card-link]');
    var title = card.querySelector('.gh-card__title');
    if (img && pic.src) {
      if (pic.srcset) img.setAttribute('srcset', pic.srcset); else img.removeAttribute('srcset');
      img.setAttribute('src', pic.src);
    }
    if (link && pic.url) link.setAttribute('href', pic.url);
    if (title && pic.url) title.setAttribute('href', pic.url);
    /* a same-design twin sold under another name (Monterey / Ventura) shows its own name */
    if (title && pic.title) title.textContent = pic.title;
    card.querySelectorAll('.gh-swatch').forEach(function (s) { s.classList.toggle('is-current', s === swatch); });
  }

  function onSwatch(swatch) {
    var card = swatch.closest('[data-gh-card]');
    if (!card) return;
    var original = remember(card);
    card.__ghWanted = swatch;
    if (swatch.hasAttribute('data-gh-sw-own')) { show(card, original, swatch); return; }
    /* a colour that is a variant of this same product (leather seat) carries its own picture */
    var own = swatch.getAttribute('data-gh-sw-src');
    if (own) {
      var base = (own.indexOf('//') === 0 ? window.location.protocol + own : own).split('?')[0];
      var pic = { src: sizedUrl(base, 1200), srcset: [400, 800, 1200].map(function (w) { return sizedUrl(base, w) + ' ' + w + 'w'; }).join(', '), url: swatch.getAttribute('href'), title: '' };
      var pre = new Image();
      pre.onload = function () { if (card.__ghWanted === swatch) show(card, pic, swatch); };
      pre.src = pic.src;
      return;
    }
    var handle = swatch.getAttribute('data-gh-sw');
    if (!handle) return;
    colourImage(handle).then(function (pic) {
      if (!pic || card.__ghWanted !== swatch) return;
      var pre = new Image();
      pre.onload = function () { if (card.__ghWanted === swatch) show(card, pic, swatch); };
      pre.src = pic.src;
    });
  }

  function onLeave(card) {
    if (!card.__ghOriginal) return;
    card.__ghWanted = null;
    var own = card.querySelector('[data-gh-sw-own]');
    show(card, card.__ghOriginal, own);
  }

  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest && e.target.closest('[data-gh-card] .gh-swatch');
    if (sw) onSwatch(sw);
  });
  document.addEventListener('focusin', function (e) {
    var sw = e.target.closest && e.target.closest('[data-gh-card] .gh-swatch');
    if (sw) onSwatch(sw);
  });
  document.addEventListener('mouseout', function (e) {
    var card = e.target.closest && e.target.closest('[data-gh-card]');
    if (card && !card.contains(e.relatedTarget)) onLeave(card);
  });
  /* warm the cache when the pointer reaches a card, so the swap feels instant */
  document.addEventListener('mouseover', function (e) {
    var card = e.target.closest && e.target.closest('[data-gh-card]');
    if (!card || card.__ghWarm) return;
    card.__ghWarm = true;
    card.querySelectorAll('[data-gh-sw]').forEach(function (s) { colourImage(s.getAttribute('data-gh-sw')); });
  });
})();
